<script>
import Header from './common/Header.vue';

export default {
    name: 'App',
    components: {
        Header
    }
};
</script>

<template>
    <Header></Header>
    <div class="content-container">
        <router-view></router-view>
    </div>
</template>